export enum TestingAgenciesEnum {
    Hospice = "81e63c0c-2ded-4fd0-a685-349d0b010e6c",
    Palliative = "3a0311a5-5426-9a59-6911-ca64d14f9436",
    HomeHealth = "14c5e22f-3f32-44d4-8e6c-894b3e79a418",
    HomeCare = "122ec20a-705b-4974-9437-8f6233a6e953",
    HCDemoSkill = "e29c418a-a0e2-4187-94cf-76f906ef6e54"
}
